module.exports = __webpack_public_path__ + "static/media/type-post-seri.382121f4.png";